import { useSelector } from 'react-redux'
import useSnackbar from '@/hooks/ui/use-snackbar.hook'
import SnackbarWrapper from '@/views/components/snackbar/snackbar.component'

import { ApplicationState } from '@/state/root.models'
import GlobalPageLoader from '@/views/components/global-page-loader/index.component'

const UiFeedbackComponent = () => {
  const { snackbar, closeHandler } = useSnackbar({})

  const { isLoadingFull } = useSelector(
    ({ globalUi }: ApplicationState) => globalUi,
  )

  return (
    <>
      <SnackbarWrapper
        message={snackbar.message}
        open={snackbar.open}
        handleClose={closeHandler}
        variant={snackbar.variant}
        automaticClose
      />
      <GlobalPageLoader open={isLoadingFull} />
    </>
  )
}

export default UiFeedbackComponent
